import { LitElement, html } from 'lit';
import '../../../shared/components/table/Table';
import '../../../shared/components/icons/IconArrowRight';
import styles from './styles';

class JobBoardTable extends LitElement {
  static styles = styles;

  static properties = {
    jobs: {
      type: Array,
      state: true,
    },
  };

  constructor() {
    super();
    this.jobs = [];
  }

  connectedCallback() {
    super.connectedCallback();
  }

  render() {
    if (this.jobs.length <= 0) {
      return html`
        <p>No jobs found matching your filter</p>
      `;
    }

    const columns = [
      {
        name: 'Job Title',
        accessor: 'title',
        Cell: (job) => html`<div class="override-cell">${job.title}</div>`,
        sort: true,
      },
      {
        name: 'Category',
        accessor: 'category.value',
        sort: true,
      },
      {
        name: 'Location',
        accessor: 'location.value',
        sort: true,
      },
      {
        name: '',
        accessor: 'url',
        Cell: () => html`
        <div style="
          position: relative;
        ">
          <tenable-icon-arrow-right stroke-color="#fff" style="
            position: absolute;
            top: -.5rem;
            right: .5rem;
          "></tenable-icon-array-right>
        </div>`,
        sort: false,
      },
    ];

    return html`
      <tenable-table
        class="job-board-table" .
        no-data-msg="No jobs found matching your filter"
        .columns=${columns}
        .data=${this.jobs}
        ?hover-highlight=${true}
        ?sorting=${true}
        ?clickable-row=${true}
      ></tenable-table>
    `;
  }
}

customElements.define('tenable-job-board-table', JobBoardTable);
